import processShim from "process/browser";

// Some third-party bundles expect a global `process` in browser runtime.
if (typeof globalThis !== "undefined" && !globalThis.process) {
  globalThis.process = processShim;
}
